.collapse {
  display: block;
  padding-block-end: var(--wc-collapse--pbe, var(--fdt-core-spacing-3));
  padding-block-start: var(--wc-collapse--pbs, var(--fdt-core-spacing-3));
  border-block-end-width: var(--wc-collapse--bbe-width, var(--divider--width));
  border-block-end-color: var(--fdt-semantic-color-border-subtle);
  border-block-end-style: var(--divider--style);
  width: 100%;
}
.collapse .collapse__summary {
  display: flex;
  gap: var(--fdt-core-spacing-1);
  align-items: center;
  padding-block: 0 var(--wc-collapse-summary--pb);
  cursor: pointer;
  list-style: none;
  margin: 0 10px;
}
.collapse .collapse__summary:focus-visible {
  outline: var(--fdt-button-color-focus-border) solid 2px;
}
.collapse .collapse__summary .collapse__summary-title {
  display: flex;
  width: 100%;
  overflow: hidden;
  align-items: center;
  gap: var(--fdt-core-spacing-1);
}
.collapse[data-size=medium] .collapse__panel, .collapse[data-size=large] .collapse__panel {
  padding-block-end: var(--fdt-core-spacing-2);
}
.collapse[data-size=large] {
  padding-block-start: var(--fdt-core-spacing-4);
  padding-block-end: var(--fdt-core-spacing-4);
}
.collapse[data-size=large] .collapse__panel {
  padding-block-start: calc(var(--fdt-core-spacing-2) + var(--fdt-core-spacing-3));
}
.collapse[data-size=medium] {
  padding-block-start: var(--wc-collapse-medium--pbs, var(--fdt-core-spacing-3));
  padding-block-end: var(--wc-collapse-medium--pbe, var(--fdt-core-spacing-3));
}
.collapse[data-size=medium] .collapse__panel {
  padding-block-start: var(--wc-collapse-medium-panel--pbs, var(--fdt-core-spacing-3));
}
.collapse:first-of-type {
  padding-block-start: 0;
}
.collapse .collapse__more[aria-expanded=true] svg {
  transform: scale(-1);
}

.collapse__panel {
  display: flex;
  flex-direction: column;
  gap: var(--fdt-core-spacing-2);
  margin: 10px 10px 0 10px;
}
.collapse__panel li[aria-hidden=true] {
  display: none;
}
.collapse__panel li a {
  --link--p: var(--fdt-core-spacing-1) 0px;
}

.collapse__icon {
  fill: var(--wc-collapse__icon--color, var(--fdt-semantic-color-foreground-subtle));
  display: var(--wc-collapse__icon--display);
  margin-inline-start: var(--wc-collapse__icon--mis, auto);
  will-change: transform;
  transform: var(--wc-collapse__icon--transform);
  transition: transform 0.2s ease-in-out;
}

.collapse__icon--rotated {
  transform: rotate(180deg);
}

.collapse__more {
  margin-top: var(--fdt-core-spacing-2);
}
.collapse__more button {
  background-color: transparent;
  border: none;
  color: var(--fdt-semantic-color-primary);
  cursor: pointer;
  display: flex;
  gap: var(--fdt-core-spacing-1);
  align-items: center;
  text-transform: uppercase;
  font-weight: bold;
}

.u-truncate-multi {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: var(--truncate-multi);
}

.flexbox {
  display: flex;
  flex-direction: column;
  gap: var(--fdt-core-spacing-1);
}

.u-truncate-multi-checkboxes {
  overflow: hidden;
  max-height: calc(1.5rem * var(--truncate-multi));
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */